import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth, useIsPlatformAdmin } from '../../hooks/useAuth'
import { useBreadcrumbs } from '../../hooks/useBreadcrumbs'
import { PageHeader } from '../../components/shared/PageHeader'
import { SECTION_ICONS } from '../../lib/section-icons'
import { ProposedRulesList } from '../../components/admin/ProposedRulesPage'

export const Route = createFileRoute('/admin/proposed-rules')({
  component: RouteComponent,
})

// Organization rules proposed for the shared catalogue (spec 2026-10-27-21).
// Platform admins only.
function RouteComponent() {
  const { t } = useTranslation('admin')
  const { loading, orgCode } = useAuth()
  const isPlatformAdmin = useIsPlatformAdmin()
  const navigate = useNavigate({ from: '/admin/proposed-rules' })

  useEffect(() => {
    if (!loading && !isPlatformAdmin) {
      navigate({ to: '/', replace: true })
    }
  }, [loading, isPlatformAdmin, navigate])

  const breadcrumbOrg = orgCode || 'demo'
  useBreadcrumbs([
    { title: t('common:nav.home'), path: `/${breadcrumbOrg}` },
    { title: t('settings:page.title'), path: `/${breadcrumbOrg}/settings` },
    { title: t('proposed_rules.title') },
  ])

  if (loading || !isPlatformAdmin) {
    return null
  }

  return (
    <div className="space-y-6" data-testid="proposed-rules-page">
      <PageHeader icon={SECTION_ICONS.businessRules} title={t('proposed_rules.title')} description={t('proposed_rules.subtitle')} />
      <ProposedRulesList />
    </div>
  )
}
